import React from "react";
import HelloMarquee from "../components/HelloMarquee";
import { Helmet } from "react-helmet";


export default function Home() {
    return (
        <>
            <Helmet>
                <title>Home | John Mangahis</title>
            </Helmet>
            <div className="home-heading-container">
                <p className="heading-small-caption">You've reached the portfolio of:</p>
                <h1>John Mangahis:</h1>
                <h2>.NET developer, UI designer.</h2>
            </div>
            <HelloMarquee/>
        </>
    )
}